import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { HiOutlineChevronDown, HiOutlineChevronUp } from 'react-icons/hi';
import useNotice from '@src/hooks/useNotice';
import { dateForamt } from '@src/utils/date';
import { convertLinksToHyperlinks } from '@src/utils/community';

const index = () => {
  const { fetchNotice } = useNotice();
  //TODO start,end api나오면 적용시켜줘야함;
  const { data: noticeList } = fetchNotice();
  const [isClick, setIsClick] = useState('');
  return (
    <>
      {noticeList &&
        noticeList.map((notice) => (
          <>
            <Container
              onClick={() => {
                setIsClick((prev) => (prev === notice.uuid ? '' : notice.uuid));
              }}
              key={notice.uuid}
            >
              <ContentWrap>
                <DateLine>{dateForamt(notice.createdAt)}</DateLine>
                <Content>{notice.title}</Content>
              </ContentWrap>
              {isClick !== notice.uuid ? <DownArrow /> : <UpArrow />}
            </Container>
            {isClick === notice.uuid && (
              <DetailContainer>
                <DetailContent
                  dangerouslySetInnerHTML={convertLinksToHyperlinks(
                    notice.content
                  )}
                ></DetailContent>
              </DetailContainer>
            )}
          </>
        ))}
    </>
  );
};

const Container = styled.div`
  width: 100%;
  padding: 15px 25px;
  border-bottom: 1px solid ${({ theme }) => theme.commonColor.gray002};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const DetailContainer = styled.div`
  background-color: ${({ theme }) => theme.commonColor.gray001};
  padding: 15px 25px;
`;

const DetailContent = styled.div`
  font-size: 14px;
  white-space: pre-wrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
`;

const ContentWrap = styled.div`
  flex: 1;
`;
const DateLine = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.commonColor.gray005};
  padding: 5px 0px;
`;
const Content = styled.div`
  font-size: 18px;
  font-weight: 700;
  padding: 5px 0px;
`;

const UpArrow = styled(HiOutlineChevronUp)``;
const DownArrow = styled(HiOutlineChevronDown)``;

export default index;
